export default class Status {
    constructor({ id, startTurn = 0, pokemon }) {
        this.id = id;
        this.startTurn = startTurn;
        this.pokemon = pokemon;
        this.currentTurn = 0;

        this.duration = {
            paralysis: Number.MAX_SAFE_INTEGER,
            poison: Number.MAX_SAFE_INTEGER,
            bad_poison: Number.MAX_SAFE_INTEGER,
            burn: Number.MAX_SAFE_INTEGER,
            freeze: Math.floor(Math.random() * 4) + 1,
            sleep: Math.floor(Math.random() * 4) + 1,
        }[id];

        this.movePreventionChance = {
            paralysis: 0.25,
            poison: 0,
            sleep: 1,
            burn: 0,
            freeze: 1,
        }[id];

        this.affectedText = {
            paralysis: `${this.pokemon.name} was paralyzied!`,
            poison: `${this.pokemon.name} was poisoned!`,
            bad_poison: `${this.pokemon.name} was badly poisoned!`,
            burn: `${this.pokemon.name} was burned!`,
            freeze: `${this.pokemon.name} was frozen!`,
            sleep: `${this.pokemon.name} fell asleep!`,
        }[id];

        this.disaffectedText = {
            paralysis: `${this.pokemon.name} is no longer paralyzied!`,
            poison: `${this.pokemon.name} is no longer poisoned!`,
            bad_poison: `${this.pokemon.name} is no longer poisoned!`,
            burn: `${this.pokemon.name} is no longer burned!`,
            freeze: `${this.pokemon.name} thawed out!`,
            sleep: `${this.pokemon.name} woke up!`,
        }[id];

        this.startTurnEffectText = {
            paralysis: `${this.pokemon.name} is paralyzed! It can't move!`,
            sleep: `${this.pokemon.name} is asleep.`,
            freeze: `${this.pokemon.name} is frozen soid.`,
        }[id];

        this.endTurnEffectText = {
            poison: `${this.pokemon.name} was hurt by poison.`,
            bad_poison: `${this.pokemon.name} was hurt by poison.`,
            burn: `${this.pokemon.name} was hurt by burn.`,
        }[id];

        this.alreadyAffectedText = {
            paralysis: `${this.pokemon.name} is already paralyzied!`,
            poison: `${this.pokemon.name} is already poisoned!`,
            bad_poison: `${this.pokemon.name} is already poisoned!`,
            burn: `${this.pokemon.name} is already burned!`,
            freeze: `${this.pokemon.name} is already frozen!`,
            sleep: `${this.pokemon.name} is already asleep!`,
        }[id];
    }

    static getDuration(statusId) {
        return {
            paralysis: -1,
            poison: -1,
            bad_poison: -1,
            burn: -1,
            freeze: Math.floor(Math.random() * 7) + 1,
            sleep: Math.floor(Math.random() * 7) + 1,
        }[statusId];
    }

    getEffectDamage() {
        return {
            poison: Math.ceil(this.pokemon.stats.maxHp * (1 / 8)),
            bad_poison: Math.ceil(
                this.pokemon.stats.maxHp * (1 / 16) * (this.currentTurn - this.startTurn + 1)
            ),
            paralysis: 0,
            burn: Math.ceil(this.pokemon.stats.maxHp * (1 / 16)),
            freeze: 0,
            sleep: 0,
        }[this.id];
    }
}

export class VolatileStatus {
    static getTurns(id) {
        switch (id) {
            case 'flinch':
                return 1;
            case 'confusion':
                return 2 + Math.round(Math.random() * 3);
            case 'pumped':
                return Number.MAX_SAFE_INTEGER;
            case 'rooted':
                return Number.MAX_SAFE_INTEGER;
            case 'seeded':
                return Number.MAX_SAFE_INTEGER;
            case 'aqua_ring':
                return Number.MAX_SAFE_INTEGER;
            case 'protect':
                return 1;
            case 'forced_out':
                return 1;
        }
    }
}
